import { render } from "./CASIPrequestions.vue?vue&type=template&id=7af845da&scoped=true"
import script from "./CASIPrequestions.vue?vue&type=script&lang=js"
export * from "./CASIPrequestions.vue?vue&type=script&lang=js"

import "./CASIPrequestions.vue?vue&type=style&index=0&id=7af845da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af845da"]])

export default __exports__